
export const GET_DETAIL_ACCOUNT = '1C'
export const GET_DETAIL_ACCOUNT_SUCCESS = '1C1'
export const UPDATE_DETAIL_ACCOUNT = '1C2'

export const MARK_MOVIES_WATCHLIST = '2C'

export const UNMARK_MOVIES_WATCHLIST = '3C'

export const MARK_MOVIES_FAVORITE = '4C'

export const UNMARK_MOVIES_FAVORITE = '5C'
